export default __webpack_public_path__ + "static/media/YuGothicUI.e8b46d95.ttf";